<template>
  <div v-if="selectGateway && !desktopDisabled" class="vnc-client vnc-container" ref="vncclient">

  </div>
  <div v-else>
    <a-empty
        style="margin-top: 100px"
        description="该功能不支持此类型网关"
    ></a-empty>
  </div>
</template>

<script>
import {GatewayServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'
import { MasterlinkTenantServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import Vue from 'vue'
const igsp = new GatewayServiceProxy();
const systemService = new MasterlinkTenantServiceProxy();

export default Vue.extend({
  components: {
  },
  props: {
    gateway:{
      type: Object,
      default: undefined
    },
    desktopDisabled:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      selectGateway: '',
    }
  },
  computed: {
    gatewayCode(){
      return this.gateway?.code || ''
    },
    hardwareType(){
      return this.gateway?.hardwareType || ''
    },

  },
  mounted() {
    this.selectGateway = this.gatewayCode
    this.getTenants()
    this.changeGateway()
  },
  created() {
  },
  destroyed() {
    if(this.vncClient){
      this.vncClient.dispose();
    }
  },
  methods: {
    changeGateway() {
      this.$nextTick(() => {
        this.initDesktop();
      });
    },
    initDesktop(){
      if(this.vncClient){
        this.vncClient.dispose();
        this.vncClient= undefined;
      }

      if (this.desktopDisabled){
        return
      }

      let url = '';
      if(window.masterlink && window.masterlink.webSocketBaseUrl) {
        url = masterlink.webSocketBaseUrl;
      } else {
        const location =  (window.location);
        const wssProtocol = location.protocol==='https:'?'wss://':'ws://';
        const hostArray = location.host.split('.');
        console.log(hostArray);
        if(hostArray.length>2){
          hostArray[0]='www';
        }else{
          hostArray.unshift('www');
        }
        const wwwHost = hostArray.join('.');
        url = `${wssProtocol}${wwwHost}`;

      }

      const uri = new URL(url);
      const opt= {
        username: 'android',
        server: uri.hostname,
        proxy: true,
        hostId: this.selectGateway,
        protocol: uri.protocol==='wss:'?'wss':'ws',
        port: uri.port||(uri.protocol==='wss:'?443:80),
        servicePath:'/ws-vncproxy',
      };
      console.log(opt);

      this.vncClient= new window.vnc.ui.clientui(this.$refs.vncclient, opt);
      this.vncClient.start();

    },
    async getData() {
      console.log('getData');
      let path = this.$route.path
      if(~path.indexOf('iot-console')) {
        let params = {
          current: 1,
          filter: '',
          size: -1,
          tenantId: this.selectTenant,
          isOnline: undefined,
          batchCode: undefined,
          ascs: undefined,
          descs: undefined
        }
        let { items } = await igsp.findGatewayList(params)
        this.gateways = items.map((item) => ({
          sn: item.code,
        }));
      } else {
        const { records } = await service.queryGatewayList(1, false, undefined, -1, this.selectTenant);
        this.gateways = records.map((item) => ({
          sn: item.sn,
        }));
      }
    },
    async getTenants() {
      const {
        data: { records },
      } = await systemService.getTenants(undefined, 1, -1, undefined, undefined);
      this.tenants = records.map(item => ({ label: item.tenantName, value: item.tenantId }))
    },
  },
  watch:{
    gatewayCode(){
      this.selectGateway = this.gatewayCode
      this.changeGateway()
    }
  }
})
</script>

<style lang="less" scoped>

</style>
